function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DatastudioReportService from '@/apps/data-platform/services/visualization/datastudio_report_service';
import PlanDataList from '@/modules/data_strategy/components/PlanDataList.vue';
import PlanPilarList from '@/modules/data_strategy/components/PlanPilarList.vue';
import DivisionList from '@/modules/data_strategy/components/DivisionsList.vue';
import SystemList from '@/modules/data_strategy/components/SystemList.vue';
import EntityList from '@/modules/data_strategy/components/EntityList.vue';
import OportunityList from '@/modules/data_strategy/components/OportunityList.vue';
import MvpList from '@/modules/data_strategy/components/MvpList.vue';
import IndustryList from '@/modules/data_strategy/components/IndustryList.vue';
import utils from '@/js/utils';
import { textsDefaul, envConfig, ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW } from '@/js/constants';
var NOT_REPORTS = 'There are not report to assign';
export default {
  name: 'DataStrategy',
  components: {
    PlanDataList: PlanDataList,
    PlanPilarList: PlanPilarList,
    DivisionList: DivisionList,
    SystemList: SystemList,
    EntityList: EntityList,
    OportunityList: OportunityList,
    MvpList: MvpList,
    IndustryList: IndustryList
  },
  data: function data() {
    return {
      fields: [{
        key: 'object_name',
        label: 'Report',
        sortable: true
      }, {
        key: 'data_operator',
        label: 'Data Operator'
      },
      //{ key: 'columns.length', label: 'Columns', class: 'text-center' },
      //{ key: 'total_tables', label: 'Total Tables', class: 'text-center' },
      {
        key: 'environment',
        label: 'Environment',
        class: 'text-center'
      }, {
        key: 'creation_date',
        label: 'Creation time',
        class: 'text-center'
      }, {
        key: 'action',
        label: '',
        class: 'w-15 text-center'
      }],
      items: [],
      // Representa la colección de objetos
      data_list: [],
      data_rp: {},
      // representa los datos generales
      messageEmptyList: textsDefaul.LOADING,
      path_name: '',
      limit: envConfig.pagintaionSize,
      page: 1,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      pagination: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      isValidateLink: false,
      show_editor: false,
      nodes: {
        node1: {
          name: "Node 1"
        },
        node2: {
          name: "Node 2"
        },
        node3: {
          name: "Node 3"
        },
        node4: {
          name: "Node 4"
        }
      },
      edges: {
        edge1: {
          source: "node1",
          target: "node2"
        },
        edge2: {
          source: "node2",
          target: "node3"
        },
        edge3: {
          source: "node3",
          target: "node4"
        }
      }
    };
  },
  computed: {
    isEmptyTable: function isEmptyTable() {
      return !this.items.length;
    },
    composeName: function composeName() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (item) {
          text = "".concat(item.path_name, "/").concat(item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
        }
        return text;
      };
    }
  },
  created: function created() {
    this.reloadList();
  },
  methods: {
    onOpenEditor: function onOpenEditor() {
      this.show_editor = !this.show_editor;
    },
    refreshItem: function refreshItem(item) {
      var index = this.items.findIndex(function (record) {
        return record.dataset_id === item.dataset_id;
      });
      this.$set(this.items, index, item);
    },
    onClickAssign: function onClickAssign(item) {
      var dataRequest = {
        domain: window.userInfo.domain,
        clauses: {
          document_id: item.id
        }
      };
      this.data_rp = null;
      /*biDatasetService.tableauDataSourceQuery(dataRequest).then((res) => {
        if (res.code === 200 && res.success) {
          this.data_rp = res.data.result
          this.path_name = `${this.data_rp.path_name}`
          this.$refs['my-modal'].show()
        }
      })*/
      this.data_rp = item;
      this.path_name = "".concat(this.data_rp.path_name);
      this.$refs['my-modal-meta'].show();
    },
    processParams: function processParams(params) {
      var filters = [{
        key: 'environment',
        operator: 'in',
        value: [ENVIRONMENT_FLOW.DEV, ENVIRONMENT_FLOW.TEST]
      }];
      if (params && params.clauses) {
        var clauses = params.clauses;
        if (clauses.query_type !== 'advanced') {
          for (var _i = 0, _Object$keys = Object.keys(clauses); _i < _Object$keys.length; _i++) {
            var key = _Object$keys[_i];
            if (clauses[key] && clauses[key].trim()) {
              filters.push({
                key: key,
                operator: '==',
                value: clauses[key].trim()
              });
            }
          }
        }
      }
      return _objectSpread({
        domain: window.userInfo.domain,
        pagination: {
          limit: this.limit,
          offset: this.page
        },
        filters: filters
      }, params);
    },
    reloadList: function reloadList(params) {
      var _this = this;
      this.items = [];
      var defaultParams = this.processParams(params);
      this.messageEmptyList = textsDefaul.LOADING;
      DatastudioReportService.getReports(defaultParams).then(function (res) {
        if (res && res.code === 200) {
          _this.items = res.data;
          _this.data_list = Object.assign([], res.data);
          _this.pagination.total = res.data.length;
          _this.currentPage = 1;
          _this.messageEmptyList = res.data.length === 0 ? NOT_REPORTS : null;
        } else if (res && res.code === 400) {
          console.info(res);
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    onCloseModal: function onCloseModal() {
      this.$bvModal.hide('my-modal-meta');
      this.reloadList();
      this.data_rp = {};
    },
    onSearchQuery: function onSearchQuery(data) {
      this.pagination.current = 1;
      if (data.clauses) {
        console.log(data, this.data_list);
        if (data.clauses.query_type == 'advanced') {
          var search = data.clauses.query.toUpperCase();
          this.items = this.data_list.filter(function (x) {
            return x.data_operator.toUpperCase().indexOf(search) != -1 || x.environment.toUpperCase().indexOf(search) != -1 || x.object_name.toUpperCase().indexOf(search) != -1 || x.path_name.toUpperCase().indexOf(search) != -1;
          });
        } else {
          this.items = Object.assign([], this.data_list);
          if (data.clauses.object_name) this.items = this.items.filter(function (x) {
            return x.object_name.toUpperCase().indexOf(data.clauses.object_name.toUpperCase()) != -1;
          });
          if (data.clauses.path_name) this.items = this.items.filter(function (x) {
            return x.path_name.toUpperCase().indexOf(data.clauses.path_name.toUpperCase()) != -1;
          });
          if (data.clauses.data_operator) this.items = this.items.filter(function (x) {
            return x.data_operator.toUpperCase().indexOf(data.clauses.data_operator.toUpperCase()) != -1;
          });
          if (data.clauses.environment) this.items = this.items.filter(function (x) {
            return x.environment.toUpperCase().indexOf(data.clauses.environment.toUpperCase()) != -1;
          });
        }
      } else {
        this.items = Object.assign([], this.data_list);
      }
      this.pagination.total = this.items.length;
    },
    onPage: function onPage(page) {
      this.page = page;
      this.reloadList({
        page: page
      });
    },
    changePagina: function changePagina(pagina) {},
    openModalMeta: function openModalMeta() {
      this.data_rp = {};
      this.isValidateLink = true;
      this.$refs['my-modal-meta'].show();
    }
  }
};